<template>
  <div class="keyAdvantage-body">
    <div class="text-wrapper-big">
      <div class="text-wrapper">
        <div class="title">Massive Market Opportunity</div>
        <div class="text">
          $35 trillion global retail market with untapped potential for unsold
          goods management.
        </div>
      </div>
      <div class="line" />
      <div class="text-wrapper">
        <div class="title">Regulatory Edge</div>
        <div class="text">
          Leveraging new EU regulations banning the destruction of unsold goods,
          making Wecobi the preferred platform for compliance.
        </div>
      </div>
      <div class="line" />
      <div class="text-wrapper">
        <div class="title">Scalable Technology</div>
        <div class="text">
          AI-driven platform connecting unsold goods with conscious consumers,
          providing brands with new revenue and marketing channels.
        </div>
      </div>
      <div class="line" />
      <div class="text-wrapper">
        <div class="title">Proven Leadership</div>
        <div class="text">
          A seasoned team with experience from industry giants like Klarna and
          Shopify, bringing a blend of expertise in retail, e-commerce, and
          sustainability to drive innovation and growth at Wecobi.
        </div>
      </div>
    </div>
    <div class="text-wrapper-medium">
      <div class="wrapper">
        <div class="text-wrapper">
          <div class="title">Massive Market Opportunity</div>
          <div class="text">
            $35 trillion global retail market with untapped potential for unsold
            goods management.
          </div>
        </div>
        <div class="line" />
        <div class="text-wrapper">
          <div class="title">Regulatory Edge</div>
          <div class="text">
            Leveraging new EU regulations banning the destruction of unsold
            goods, making Wecobi the preferred platform for compliance.
          </div>
        </div>
      </div>
      <div class="line-two" />
      <div class="wrapper">
        <div class="text-wrapper">
          <div class="title">Scalable Technology</div>
          <div class="text">
            AI-driven platform connecting unsold goods with conscious consumers,
            providing brands with new revenue and marketing channels.
          </div>
        </div>
        <div class="line" />
        <div class="text-wrapper">
          <div class="title">Proven Leadership</div>
          <div class="text">
            A seasoned team with experience from industry giants like Klarna and
            Shopify, bringing a blend of expertise in retail, e-commerce, and
            sustainability to drive innovation and growth at Wecobi.
          </div>
        </div>
      </div>
    </div>
    <div class="text-wrapper-small">
      <div class="text-wrapper">
        <div class="title">Massive Market Opportunity</div>
        <div class="text">
          $35 trillion global retail market with untapped potential for unsold
          goods management.
        </div>
      </div>
      <div class="line-three" />
      <div class="text-wrapper">
        <div class="title">Regulatory Edge</div>
        <div class="text">
          Leveraging new EU regulations banning the destruction of unsold goods,
          making Wecobi the preferred platform for compliance.
        </div>
      </div>
      <div class="line-three" />
      <div class="text-wrapper">
        <div class="title">Scalable Technology</div>
        <div class="text">
          AI-driven platform connecting unsold goods with conscious consumers,
          providing brands with new revenue and marketing channels.
        </div>
      </div>
      <div class="line-three" />
      <div class="text-wrapper">
        <div class="title">Proven Leadership</div>
        <div class="text">
          A seasoned team with experience from industry giants like Klarna and
          Shopify, bringing a blend of expertise in retail, e-commerce, and
          sustainability to drive innovation and growth at Wecobi.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyAdvantages",
};
</script>

<style scoped>
.keyAdvantage-body {
  width: 100%;
  height: fit-content;
  background-color: #f7f7fa;
  border-radius: 20px;
  padding: 100px 90px;
  box-sizing: border-box;
}
.text-wrapper-big {
  display: flex;
  justify-content: space-between;
  gap: 35px;
}
.text-wrapper-medium {
  display: none;
}
.text-wrapper-small {
  display: none;
}
.text-wrapper {
  width: 315px;
  height: fit-content;
  color: #000000;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.line {
  width: 3px;
  height: 107px;
}
.line-two {
  width: 100%;
  height: 2px;
}
.line-three {
  width: 105px;
  height: 2px;
}
.line,
.line-two,
.line-three {
  background-color: #ff6d0a;
  border-radius: 20px;
}

@media (max-width: 1150px) {
  .keyAdvantage-body {
    padding: 80px 43px;
  }
  .text-wrapper-desktop {
    gap: 30px;
  }
}

@media (max-width: 850px) {
  .keyAdvantage-body {
    padding: 60px 40px;
  }
  .text-wrapper-big {
    display: none;
  }
  .text-wrapper-medium {
    display: block;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 35px;
  }
  .text-wrapper {
    width: 280px;
    gap: 25px;
  }
  .line {
    height: 136px;
  }
}
@media (max-width: 588px) {
  .text {
    font-size: 12px;
  }
}

@media (max-width: 431px) {
  .keyAdvantage-body {
    padding: 60px 30px;
  }
  .text-wrapper-medium {
    display: none;
  }
  .text-wrapper-small {
    display: block;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .text-wrapper {
    width: 100%;
    gap: 16px;
  }
}
</style>
